import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import TaskGroupContact from '../components/TaskGroupContact';

const InternationalCooperationTaskGroup = () => {
  const [teamData, setTeamData] = useState({});
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetch('/content/team.json')
      .then(res => res.json())
      .then(data => {
        setTeamData(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading team data:', error);
        setLoading(false);
      });
  }, []);

  // Filter members who are in International Cooperation Task Group
  const getTaskGroupMembers = () => {
    if (!teamData.boardMembers) return [];

    const members = teamData.boardMembers.filter(member =>
      member.taskGroups && member.taskGroups.includes('International Cooperation Task Group')
    );

    // Sort so Andreea Żak (Task Group Lead) comes first
    return members.sort((a, b) => {
      if (a.role === 'Task Group Lead') return -1;
      if (b.role === 'Task Group Lead') return 1;
      return 0;
    });
  };

  // Associations data
  const associations = [
    { country: 'Belgium', name: 'VVDO - Vlaamse Vereniging van Deskundigen in de Oplossingsgerichte', website: 'https://www.vvdo.be/' },
    { country: 'Finland', name: 'Ratkes', website: 'https://ratkes.fi/' },
    { country: 'France', name: 'AFACS', website: 'https://www.ifaacs.com/les-formations' },
    { country: 'Georgia', name: 'Georgian Brief Psychotherapy Association', website: 'https://www.facebook.com/profile.php?id=61560310154194' },
    { country: 'Italy', name: 'Fondazione Franceschi ONLUS', website: 'http://www.fondazionefranceschi.org/' },
    { country: 'Poland', name: 'Polish Association for Solution-Focused Psychotherapists PTPSR', website: 'https://www.ptpsr.pl/' },
    { country: 'Poland', name: 'Polish Association of Therapists in Solution-Focused Therapy PSTTSR', website: 'https://psttsr.pl/' },
    { country: 'Poland', name: 'Solution Focused Approach Section of the Polish Psychology Association PTP', website: 'https://psych.org.pl/sekcje/sekcja-podejscia-skoncentrowanego-na-rozwiazaniach-psr' },
    { country: 'Romania', name: 'Romanian Association for Short-term Therapy and Consultancy Oriented on Resources and Solutions', website: 'https://www.facebook.com/psihoterapiiscurte.org/about' },
    { country: 'Russia', name: 'Russian Association of SF-therapists', website: 'https://www.facebook.com/groups/412206010373110' },
    { country: 'Spain', name: 'Imagine. Canarian association for the development of solution-focused practice', website: 'https://imaginebrieftherapy.com/' },
    { country: 'Spain', name: 'Spanish Association of Systemic Brief Therapy [Aliancia Spaniola de Terapia Sistemica Breve]', website: 'https://aetsb.org/' },
    { country: 'Sweden', name: 'SFLK - Svenska föreningen för lösningsfokuserad korttidsterapi', website: 'https://www.sflk.org/' },
    { country: 'Switzerland', name: 'NLA - Swiss Network for Solution-Focused Practices', website: 'https://www.nla-schweiz.ch/' },
    { country: 'UK', name: 'United Kingdom Association for Solution Focused Practices (UKASFP)', website: 'https://members.ukasfp.org/page/UKASFP' }
  ];

  // Training centres data with IASTI marking
  const trainingCentres = [
    { country: 'Austria', name: 'Austrian Solution Circle', city: 'Vienna', website: 'https://austriansolutioncircle.at/', iasti: false },
    { country: 'Belgium', name: 'Centrum Oplossingsgericht Coachen', city: '', website: 'https://www.centrumoplossingsgerichtcoachen.be/', iasti: true },
    { country: 'Belgium', name: 'Korzybski Instituut (Institute Korzybski)', city: 'Bruges', website: 'https://www.korzybski.be/nl/homepagina', iasti: true },
    { country: 'Belgium', name: 'Thepco', city: 'Blankenberge', website: 'http://www.thepco.be/', iasti: true },
    { country: 'Czech Republic', name: 'Institute Dalet', city: 'Olomouc', website: 'https://www.dalet.cz/', iasti: false },
    { country: 'Denmark', name: 'Dansk Løsningsfokuseret Institut / Danish Solution Focused Institute', city: 'Kongens Lyngby', website: 'http://www.danskloesningsfokuseretinstitut.dk', iasti: true },
    { country: 'Finland', name: 'Furman consulting', city: 'Helsinki', website: 'https://benfurman.com/WP2/', iasti: false },
    { country: 'Finland', name: 'Helsinki Brief Therapy Institute', city: 'Helsinki', website: 'http://www.lti.fi/', iasti: true },
    { country: 'Finland', name: 'TaitoBa', city: 'Helsinki', website: 'https://www.taitoba.fi/ihmiset', iasti: false },
    { country: 'France', name: 'IICoS Institut interculturel de compétences systémiques (Intercultural Institute of Systemic Competences)', city: 'Marlenheim', website: 'http://www.iicos.org/', iasti: false },
    { country: 'France', name: 'Pegasus', city: 'Chantepie', website: 'https://www.pegase-processus.fr/', iasti: false },
    { country: 'France', name: 'Cercle de Competences', city: 'Lyon', website: 'https://www.cercledecompetences.org/', iasti: false },
    { country: 'France', name: 'Association Alternatives', city: 'Grenoble', website: 'https://www.alternatives-acs.fr/', iasti: false },
    { country: 'France', name: 'IFA ACS', city: '', website: 'https://www.ifaacs.com/les-formations', iasti: false },
    { country: 'Germany', name: 'ifR Hamburg', city: 'Hamburg', website: 'https://ifrhamburg.de/', iasti: true },
    { country: 'Germany', name: 'ILBB Institut Für Lösungsorienterte Beratung', city: 'Brühl', website: 'http://www.gutberaten.cologne/', iasti: true },
    { country: 'Germany', name: 'ILK Institut für Lösungsfokussierte Kommunikation', city: 'Bielefeld', website: 'http://www.loesungsfokussiert.de/', iasti: true },
    { country: 'Germany', name: 'Norddeutsches Institut fur Kurzzeittherapie N.I.K.', city: 'Bremen', website: 'http://www.nik.de/', iasti: true },
    { country: 'Germany', name: 'Solutionsacademy', city: '', website: 'http://solutionsacademy.com/', iasti: true },
    { country: 'Georgia', name: 'Georgian Brief Psychotherapy Association', city: 'Tbilisi', website: 'https://www.facebook.com/profile.php?id=61560310154194', iasti: false },
    { country: 'Italy', name: 'Fondazione Franceschi ONLUS', city: 'Firenze', website: 'http://www.fondazionefranceschi.org/', iasti: false },
    { country: 'Latvia', name: 'Solution-focused and narrative therapy in Latvia', city: '', website: 'https://www.facebook.com/SFLatvija', iasti: false },
    { country: 'Poland', name: 'CTK Centrum terapii krótkoterminowej (Brief therapy center)', city: 'Łódź', website: 'https://www.centrumtk.com/', iasti: true },
    { country: 'Poland', name: 'Solutions Focused Approach Center', city: 'Inowrocław', website: 'https://www.centrumpsr.eu/', iasti: true },
    { country: 'Poland', name: 'LETSR', city: 'Pabianice', website: 'https://www.letsr.pl/', iasti: false },
    { country: 'Poland', name: 'Centrum rozwiązań (Solutions center)', city: 'Toruń', website: 'https://centrumrozwiazan.pl/', iasti: false },
    { country: 'Poland', name: 'Pracownia Psychologiczna Magdalena Szutarska (Psychology Studio Magdalena Szutarska)', city: 'Poznań', website: 'https://pracownia-psychologiczna.edu.pl/', iasti: false },
    { country: 'Poland', name: 'Integri TSR', city: 'Piaseczno', website: 'https://szkoleniatsr.pl/', iasti: false },
    { country: 'Poland', name: 'Centrum Terapii Skoncentrowanej na Rozwiązaniach (CTSR)', city: 'Warszawa', website: 'https://ctsr.pl/', iasti: false },
    { country: 'Poland', name: 'Śląski Ośrodek Podejścia Skoncentrowanego na Rozwiązaniach (Silezian Center for Solution Focused Approach)', city: 'Sosnowiec', website: 'https://osrodekpsr.pl/', iasti: false },
    { country: 'Russia', name: 'Moscow School of Social and Economic Sciences', city: 'Moscow', website: 'https://www.msses.ru/kursy/orientirovannaya-na-reshenie-kratkosrochnaya-terapiya/', iasti: false },
    { country: 'Russia', name: "Center for Brief and Systemic Therapy 'Predstav sebe", city: 'Online', website: 'https://sfbtpcourse.ru/specialsfcases', iasti: false },
    { country: 'Russia', name: 'Institute of Constructive Psychology', city: 'Online', website: 'https://oooikp.ru/', iasti: false },
    { country: 'Russia', name: 'IPPSY Practical Psychology Institute', city: 'Online', website: 'https://ippsy.pro/solution-focused-brief-therapy', iasti: false },
    { country: 'Russia', name: 'Psychodemia', city: 'Online', website: 'https://psychodemia.com/orkt', iasti: false },
    { country: 'Russia', name: 'Solution-Focused Therapy with Children, Adolescents and Families', city: 'Online', website: 'https://sfbt-kids.ru/', iasti: false },
    { country: 'Spain', name: 'La Casa. Canarian School of Therapy and Solution Focused Practice', city: 'Santa Cruz de Tenerife', website: 'https://www.tonimedina.es/', iasti: false },
    { country: 'Spain', name: 'Spanish Association of Brief Systemic Therapy', city: 'Salamanca', website: 'https://aetsb.org/', iasti: true },
    { country: 'Sweden', name: 'Solutionwork Institute', city: 'Stockholm', website: 'http://www.solutionwork.com/', iasti: true },
    { country: 'Switzerland', name: 'ZLB - Zentrum für lösungsorientierte Beratung', city: 'Winterthur', website: 'https://www.zlb-schweiz.ch/', iasti: false },
    { country: 'Switzerland', name: 'Istituto Marco Ronzani', city: 'Basel', website: 'https://www.istituto.ch/en/istituto.html', iasti: false },
    { country: 'UK', name: 'Eileen Murphy Consultants', city: '', website: 'http://www.brief-therapy-uk.com/', iasti: true },
    { country: 'UK', name: 'John Henden Consultancy Ltd', city: 'Somerset', website: 'http://www.johnhendenconsultancy.co.uk/', iasti: true },
    { country: 'UK', name: 'Solution Focused Trainers C.I.C.', city: 'Ryton', website: 'http://solutionfocusedtrainers.co.uk/', iasti: true }
  ];

  // Filter data based on search term
  const filteredAssociations = associations.filter(assoc =>
    assoc.country.toLowerCase().includes(searchTerm.toLowerCase()) ||
    assoc.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredCentres = trainingCentres.filter(centre =>
    centre.country.toLowerCase().includes(searchTerm.toLowerCase()) ||
    centre.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    centre.city.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const memberCardStyle = {
    backgroundColor: '#ffffff',
    padding: '1.5rem',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    transition: 'all 0.3s ease'
  };

  const sectionStyle = {
    marginBottom: '3rem',
    padding: '2rem',
    backgroundColor: '#f8fafc',
    borderRadius: '16px',
    border: '1px solid #e2e8f0'
  };

  const activityCardStyle = {
    backgroundColor: '#ffffff',
    padding: '1.5rem',
    borderRadius: '12px',
    border: '1px solid #e5e7eb',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    marginBottom: '1.5rem'
  };

  return (
    <div className="container" style={{maxWidth: '1200px', margin: '0 auto', padding: '2rem'}}>
      {/* Header */}
      <div style={{textAlign: 'center', marginBottom: '3rem'}}>
        <Link
          to="/task-groups"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            color: '#2563eb',
            textDecoration: 'none',
            marginBottom: '1rem',
            fontSize: '1rem'
          }}
        >
          ← Back to Task Groups
        </Link>
        <h1 className="page-title" style={{fontSize: '2.5rem', fontWeight: 'bold', color: '#1e293b', marginBottom: '1rem'}}>
          🌍 International Cooperation Task Group
        </h1>
        <p className="page-subtitle" style={{fontSize: '1.2rem', color: '#64748b', maxWidth: '800px', margin: '0 auto'}}>
          Promoting cooperation between National Solution Focused Associations and supporting international connections
        </p>
      </div>

      {/* Mission */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '1.5rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>🎯</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Our Mission</h2>
        </div>
        <p style={{color: '#64748b', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1.5rem'}}>
          EBTA is committed to promoting and supporting cooperation between National Solution Focused Associations and others,
          who hope to create an association, network or smaller community in countries, where they do not currently exist.
        </p>
        <p style={{color: '#64748b', fontSize: '1.1rem', lineHeight: '1.6'}}>
          EBTA is convinced that cooperation between countries, e.g. national associations, local communities and networks
          on an international level creates opportunities to do more than any could have achieved on their own.
        </p>
      </div>

      {/* Purpose & Role */}
      <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '2rem', marginBottom: '3rem'}}>

        {/* Purpose */}
        <div style={{...sectionStyle, backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0'}}>
          <div style={{display: 'flex', alignItems: 'center', marginBottom: '1.5rem'}}>
            <div style={{fontSize: '2rem', marginRight: '1rem', color: '#059669'}}>🎯</div>
            <h3 style={{color: '#166534', fontSize: '1.5rem', fontWeight: 'bold', margin: 0}}>Purpose</h3>
          </div>
          <p style={{color: '#166534', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1rem'}}>
            We encourage, support, and provide opportunities to:
          </p>
          <ul style={{color: '#166534', fontSize: '1rem', lineHeight: '1.6', paddingLeft: '1.5rem'}}>
            <li>Learn from each other's successes</li>
            <li>Share resources</li>
            <li>Consult each other at times of challenge</li>
            <li>Support the development of national associations in countries where there is potential for them to exist</li>
          </ul>
        </div>

        {/* Role */}
        <div style={{...sectionStyle, backgroundColor: '#f0f9ff', border: '1px solid #bfdbfe'}}>
          <div style={{display: 'flex', alignItems: 'center', marginBottom: '1.5rem'}}>
            <div style={{fontSize: '2rem', marginRight: '1rem', color: '#2563eb'}}>⚡</div>
            <h3 style={{color: '#1e40af', fontSize: '1.5rem', fontWeight: 'bold', margin: 0}}>Role</h3>
          </div>
          <p style={{color: '#1e40af', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1rem'}}>
            The task group's role is to:
          </p>
          <ul style={{color: '#1e40af', fontSize: '1rem', lineHeight: '1.6', paddingLeft: '1.5rem'}}>
            <li>Promote opportunities for associations, communities and networks to connect</li>
            <li>Create and establish activities which support our aim</li>
            <li>Act as a switchboard, enabling communication to happen</li>
            <li>Learn from what has been tried, repeating what works and trying new ideas</li>
          </ul>
        </div>
      </div>

      {/* Activities */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '2rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>🎪</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Current Activities</h2>
        </div>

        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '1.5rem'}}>

          {/* SF World Day */}
          <div style={{...activityCardStyle, backgroundColor: '#fef3c7', border: '1px solid #fde047'}}>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1rem'}}>
              <div style={{fontSize: '2rem', marginRight: '1rem', color: '#d97706'}}>🌍</div>
              <h4 style={{color: '#a16207', fontSize: '1.3rem', fontWeight: '600', margin: 0}}>SF World Day</h4>
            </div>
            <p style={{color: '#6b7280', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1rem'}}>
              <strong>May 3rd</strong> - A yearly day to celebrate the Solution Focused Approach around the world.
              The celebration can include a single person, community or national association.
            </p>
            <a
              href="https://www.facebook.com/groups/2205998623016615/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#d97706',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: '0.9rem'
              }}
            >
              Facebook Group →
            </a>
          </div>

          {/* SF Summer Camps */}
          <Link
            to="/summercamp"
            style={{
              ...activityCardStyle,
              backgroundColor: '#f0fdf4',
              border: '1px solid #bbf7d0',
              textDecoration: 'none',
              color: 'inherit',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 8px 15px -3px rgba(0, 0, 0, 0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
            }}
          >
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1rem'}}>
              <div style={{fontSize: '2rem', marginRight: '1rem', color: '#059669'}}>🏕️</div>
              <h4 style={{color: '#166534', fontSize: '1.3rem', fontWeight: '600', margin: 0}}>SF Summer Camps</h4>
            </div>
            <p style={{color: '#6b7280', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1rem'}}>
              <strong>Since 2016</strong> - Gathering in a relaxed atmosphere with time to reflect and share experiences,
              ideas and understandings of the Solution Focused approach. A good opportunity for exchange between
              younger practitioners and the older SF generation.
            </p>
            <div style={{
              color: '#059669',
              fontSize: '0.9rem',
              fontWeight: '600',
              textAlign: 'right'
            }}>
              Learn more →
            </div>
          </Link>

          {/* Digital Platform */}
          <div style={{...activityCardStyle, backgroundColor: '#fdf4ff', border: '1px solid #e9d5ff'}}>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1rem'}}>
              <div style={{fontSize: '2rem', marginRight: '1rem', color: '#7c2d12'}}>💻</div>
              <h4 style={{color: '#7c2d12', fontSize: '1.3rem', fontWeight: '600', margin: 0}}>Digital Platform</h4>
            </div>
            <p style={{color: '#6b7280', fontSize: '1rem', lineHeight: '1.6'}}>
              Facebook group "SF-international Cooperation Contact Group" where representatives from national associations,
              networks and groups can connect to create, promote and support opportunities for exchanging ideas and experiences.
            </p>
          </div>

          {/* Quarterly Online Gatherings */}
          <div style={{...activityCardStyle, backgroundColor: '#fef2f2', border: '1px solid #fecaca'}}>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1rem'}}>
              <div style={{fontSize: '2rem', marginRight: '1rem', color: '#dc2626'}}>📹</div>
              <h4 style={{color: '#dc2626', fontSize: '1.3rem', fontWeight: '600', margin: 0}}>Quarterly Online Gatherings</h4>
            </div>
            <p style={{color: '#6b7280', fontSize: '1rem', lineHeight: '1.6'}}>
              Facilitated by task group members, where contact persons and others with interest can meet,
              exchange experiences and share news. A way to stay in touch during difficult times such as Covid-19,
              started at the end of 2020.
            </p>
          </div>
        </div>
      </div>

      {/* Members */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '2rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>👥</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Task Group Members</h2>
        </div>

        {loading ? (
          <div style={{textAlign: 'center', padding: '2rem'}}>
            <p style={{color: '#6b7280', fontSize: '1.1rem'}}>Loading team members...</p>
          </div>
        ) : (
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.5rem'}}>
            {getTaskGroupMembers().map((member, index) => (
              <div key={index} style={memberCardStyle}>
                <div style={{
                  width: '120px',
                  height: '120px',
                  borderRadius: '50%',
                  backgroundColor: '#f3f4f6',
                  margin: '0 auto 1rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '3rem',
                  color: '#6b7280',
                  backgroundImage: member.image ? `url(${member.image})` : 'none',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}>
                  {!member.image && '👤'}
                </div>
                <h3 style={{color: '#1e293b', fontSize: '1.3rem', fontWeight: '600', marginBottom: '1rem'}}>
                  {member.name}
                </h3>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Associations & Training Centres */}
      <div style={sectionStyle}>
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '1.5rem'}}>
          <div style={{fontSize: '2rem', marginRight: '1rem'}}>🌍</div>
          <h2 style={{fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Solution-Focused Associations and Training Centers in Europe</h2>
        </div>

        {/* Description */}
        <div style={{backgroundColor: '#f0f9ff', padding: '1.5rem', borderRadius: '8px', border: '1px solid #bfdbfe', marginBottom: '2rem'}}>
          <p style={{color: '#1e40af', fontSize: '0.95rem', lineHeight: '1.7', marginBottom: '1rem'}}>
            The following lists provide an overview of European associations, networks, communities, and training opportunities in Europe known to us. They are compiled to facilitate connections at both local and international levels.
          </p>
          <p style={{color: '#1e40af', fontSize: '0.95rem', lineHeight: '1.7', marginBottom: '1rem'}}>
            EBTA does not evaluate or accredit national associations or training programs. The lists below are maintained solely for informational purposes.
          </p>
          <p style={{color: '#1e40af', fontSize: '0.95rem', lineHeight: '1.7', marginBottom: '1rem'}}>
            For details on quality standards in Solution-Focused training, as well as a list of training institutes whose programs meet common standards, please refer to the <strong>International Alliance of Solution-Focused Teaching Institutes (IASTI)</strong>.
          </p>
          <p style={{color: '#1e40af', fontSize: '0.95rem', lineHeight: '1.7'}}>
            Training centers meeting IASTI standards are marked with an asterisk (<strong>*</strong>).
          </p>
        </div>

        {/* Search Box */}
        <div style={{marginBottom: '2rem'}}>
          <input
            type="text"
            placeholder="🔍 Search by country, organization name, or city..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: '100%',
              padding: '0.75rem 1rem',
              borderRadius: '8px',
              border: '2px solid #2563eb',
              fontSize: '1rem',
              boxSizing: 'border-box'
            }}
          />
        </div>

        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(500px, 1fr))', gap: '2rem'}}>

          {/* National Associations */}
          <div>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1.5rem'}}>
              <div style={{fontSize: '1.5rem', marginRight: '0.5rem'}}>🏛️</div>
              <h3 style={{fontSize: '1.3rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>National Associations ({filteredAssociations.length})</h3>
            </div>

            <div style={{overflowX: 'auto'}}>
              <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                backgroundColor: '#ffffff',
                borderRadius: '8px',
                overflow: 'hidden',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                fontSize: '0.85rem'
              }}>
                <thead>
                  <tr style={{backgroundColor: '#f8fafc'}}>
                    <th style={{padding: '0.75rem', textAlign: 'left', fontWeight: '600', color: '#374151', borderBottom: '1px solid #e5e7eb'}}>Country</th>
                    <th style={{padding: '0.75rem', textAlign: 'left', fontWeight: '600', color: '#374151', borderBottom: '1px solid #e5e7eb'}}>Association</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredAssociations.map((assoc, index) => (
                    <tr key={index} style={{borderBottom: '1px solid #f3f4f6'}}>
                      <td style={{padding: '0.5rem 0.75rem', color: '#6b7280', fontWeight: '500'}}>
                        {assoc.country}
                      </td>
                      <td style={{padding: '0.5rem 0.75rem', color: '#374151'}}>
                        <a
                          href={assoc.website}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: '#2563eb',
                            textDecoration: 'none',
                            fontSize: '0.85rem'
                          }}
                        >
                          {assoc.name} →
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Training Centres */}
          <div>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '1.5rem'}}>
              <div style={{fontSize: '1.5rem', marginRight: '0.5rem'}}>🎓</div>
              <h3 style={{fontSize: '1.3rem', fontWeight: 'bold', color: '#1e293b', margin: 0}}>Training Centres ({filteredCentres.length})</h3>
            </div>

            <div style={{overflowX: 'auto'}}>
              <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                backgroundColor: '#ffffff',
                borderRadius: '8px',
                overflow: 'hidden',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                fontSize: '0.85rem'
              }}>
                <thead>
                  <tr style={{backgroundColor: '#f8fafc'}}>
                    <th style={{padding: '0.75rem', textAlign: 'left', fontWeight: '600', color: '#374151', borderBottom: '1px solid #e5e7eb'}}>Country</th>
                    <th style={{padding: '0.75rem', textAlign: 'left', fontWeight: '600', color: '#374151', borderBottom: '1px solid #e5e7eb'}}>Training Centre</th>
                    <th style={{padding: '0.75rem', textAlign: 'left', fontWeight: '600', color: '#374151', borderBottom: '1px solid #e5e7eb'}}>City</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCentres.map((centre, index) => (
                    <tr key={index} style={{borderBottom: '1px solid #f3f4f6'}}>
                      <td style={{padding: '0.5rem 0.75rem', color: '#6b7280', fontWeight: '500'}}>
                        {centre.country}
                      </td>
                      <td style={{padding: '0.5rem 0.75rem', color: '#374151'}}>
                        <a
                          href={centre.website}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: '#2563eb',
                            textDecoration: 'none',
                            fontSize: '0.85rem'
                          }}
                        >
                          {centre.name}{centre.iasti ? ' *' : ''} →
                        </a>
                      </td>
                      <td style={{padding: '0.5rem 0.75rem', color: '#6b7280', fontSize: '0.8rem'}}>
                        {centre.city}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <TaskGroupContact taskGroupName="International Cooperation Task Group" />
    </div>
  );
};

export default InternationalCooperationTaskGroup;
